import features from './features'

const normalizedApiPrefix = (
    process.env.REACT_APP_API_URL ||
    ''
).replace(/\/+$/, '')

const appConfig = {
    apiPrefix: normalizedApiPrefix,
    // Dashboard Redesign, Phase 1: admins land on the Command Centre when the
    // NEW_NAV flag is on; otherwise the classic sales dashboard (unchanged).
    authenticatedEntryPath: features.NEW_NAV
        ? '/app/home'
        : '/app/sales/dashboard',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/app/account/kyc-form',
    locale: 'en',
    enableMock: false,
    // Image compression setting (defaults to false - set to 'true' to enable)
    imageCompressionEnabled: false,
}

export default appConfig
